import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f61b33a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-gradient position-relative d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "btn-icon" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "under-button-phone" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.underlineText), 1)
  ], 64))
}